/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { useState, useCallback } from "react";

import { useApiConfig } from "../api-config";

import { fetchSdkDownload } from "./sdk.fetch";

export const useSdkDownloadTrigger = (): {
	triggerDownload: (archive_id: number, archive_type: string) => Promise<void>;
	isLoading: boolean;
	error?: string;
} => {
	const { serverUrl } = useApiConfig();
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | undefined>();

	const triggerDownload = useCallback(
		async (archive_id: number, archive_type: string) => {
			setIsLoading(true);
			setError(undefined);

			try {
				await fetchSdkDownload({ archive_id, archive_type }, serverUrl);
			} catch (err) {
				const errorMessage = err instanceof Error ? err.message : "Download failed";
				setError(errorMessage);
				throw err;
			} finally {
				setIsLoading(false);
			}
		},
		[serverUrl],
	);

	return {
		triggerDownload,
		isLoading,
		error,
	};
};
